"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceAuthGuard = void 0;
var useAuthGuard_1 = require("../hooks/useAuthGuard");
var DeviceAuthContextProvider_1 = require("../providers/DeviceAuthContextProvider");
var DeviceAuthGuard = function (_a) {
    var loader = _a.loader, redirectTo = _a.redirectTo, children = _a.children;
    return (0, useAuthGuard_1.useAuthGuard)({ context: DeviceAuthContextProvider_1.DeviceAuthContext, loader: loader, redirectTo: redirectTo, children: children });
};
exports.DeviceAuthGuard = DeviceAuthGuard;
